import styled from "styled-components";
import CloseImg from "@/assets/svg/close.svg";
import DiscordImg from "@/assets/svg/discord.svg";

import { ReactSVG } from "react-svg";


export default function WhiteListModal({ handleClose }) {
  
  const toDiscord = ()=>{
    window.open( 'https://discord.gg/QhePXWPwX5', '_blank');
  }

  return (
    <>
      <Modal>
        <div className="close" onClick={handleClose}>
          <ReactSVG src={CloseImg} />
        </div>
        <div className="content">          
          <div className="desc">Sorry，your wallet address is not eligible for testing，please go to discord to get the test whitelist</div>
          <div className="stake-btn" onClick={toDiscord}><ReactSVG className="discord" src={DiscordImg} beforeInjection={(svg) => { svg.setAttribute('style', 'display: flex') }}/>Join Discord</div>
        </div>
      </Modal>      
    </>
  );
}

const Modal = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  padding: 48px 35px 0 36px;
  .text-item{
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.6);
    text-align: left;
    width: 100%;
    padding-top: 12px;
  }
  .close {
    position: absolute;
    right: 35px;
    top: 22px;
    cursor: pointer;
  }
  .stake-arrow{
    margin: 10px 0;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom:30px;
    font-weight: 600;
    line-height: 34px;
    color: #32DE86;
    font-size: 20px;
    line-height: 28px;
    color: #FFFFFF;
    .stake-btn{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      box-sizing: border-box;
      height: 44px;
      line-height: 44px;
      background: #32DE86;
      border-radius: 8px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      cursor: pointer;
      font-size: 16px;     
      margin-top:30px;     
      &.disabled{
        background: rgba(255, 255, 255, 0.1);
        color: rgba(255, 255, 255, 0.3);
        cursor: auto;
      }
      .discord{
        margin-right: 9px;
        margin-bottom: -2px;
      }
    }
    
  }
`;
